import { render, staticRenderFns } from "./ChartConfig.vue?vue&type=template&id=4fbe873c&scoped=true&"
import script from "./ChartConfig.vue?vue&type=script&lang=js&"
export * from "./ChartConfig.vue?vue&type=script&lang=js&"
import style0 from "./ChartConfig.vue?vue&type=style&index=0&id=4fbe873c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe873c",
  null
  
)

export default component.exports